<template>
  <section class="trick-summary-charts">
    <article class="summary-card">
      <header class="summary-card-header">
        <h3>{{ levelTitle }}</h3>
        <span class="summary-total">{{ totalLabel }}: {{ levelTotal }}</span>
      </header>
      <div class="summary-canvas-wrap">
        <canvas ref="levelCanvas"></canvas>
      </div>
      <p v-if="!hasLevelData" class="summary-empty">{{ emptyLabel }}</p>
    </article>

    <article class="summary-card">
      <header class="summary-card-header">
        <h3>{{ categoryTitle }}</h3>
        <span class="summary-total">{{ totalLabel }}: {{ categoryTotal }}</span>
      </header>
      <div class="summary-canvas-wrap">
        <canvas ref="categoryCanvas"></canvas>
      </div>
      <p v-if="!hasCategoryData" class="summary-empty">{{ emptyLabel }}</p>
    </article>
  </section>
</template>

<script>
export default {
  name: 'TrickSummaryCharts',
  props: {
    levelTotal: {
      type: Number,
      default: 0,
    },
    categoryTotal: {
      type: Number,
      default: 0,
    },
    hasLevelData: {
      type: Boolean,
      default: false,
    },
    hasCategoryData: {
      type: Boolean,
      default: false,
    },
    labels: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    levelTitle() {
      return this.labels.levelTitle || 'Trucos por nivel';
    },
    categoryTitle() {
      return this.labels.categoryTitle || 'Trucos por categoria';
    },
    totalLabel() {
      return this.labels.total || 'Total';
    },
    emptyLabel() {
      return this.labels.empty || 'No hay datos para mostrar';
    },
  },
};
</script>

<style scoped>
.trick-summary-charts {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
}

.summary-card {
  padding: 20px;
  border-radius: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f3f5f7 100%);
  box-shadow: 0 12px 30px rgba(17, 24, 39, 0.08);
}

.summary-card-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.summary-card-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.summary-total {
  color: #5b6470;
  font-size: 0.9rem;
}

.summary-canvas-wrap {
  position: relative;
  width: 100%;
  min-height: 220px;
}

.summary-canvas-wrap canvas {
  width: 100% !important;
  height: 220px !important;
}

.summary-empty {
  margin: 16px 0 0;
  color: #6c757d;
  font-size: 0.9rem;
  text-align: center;
}

@media (max-width: 767px) {
  .trick-summary-charts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .summary-card {
    padding: 14px;
  }

  .summary-card-header {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .summary-card-header h3 {
    font-size: 0.95rem;
  }

  .summary-total,
  .summary-empty {
    font-size: 0.8rem;
  }

  .summary-canvas-wrap {
    min-height: 170px;
  }

  .summary-canvas-wrap canvas {
    height: 170px !important;
  }
}
</style>